import { useSearchParams, Link, useLocation } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import TermFaqCategory from '@/components/TermFaqCategory';

const FaqCompensationReturnReassessmentPage = () => {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const isMobile = searchParams.get('isMobile') === '1' || searchParams.get('isMobile') === 'true';

  return (
    <div className="w-full bg-white min-h-screen flex flex-col">
      {!isMobile && <Header />}
      
      <div className="w-full bg-white inline-flex justify-center overflow-hidden">
        <div className="container pt-10 pb-20 px-4 md:px-0 flex flex-col justify-start items-start gap-[60px] overflow-hidden">
          <div className="w-full flex flex-col justify-start items-start gap-2.5">
            <div className="justify-center text-black text-[40px] font-bold leading-[60px]">よくあるご質問</div>
            <div className="h-[3px] w-full relative bg-[#e4e4e4]" />
          </div>
          
          <TermFaqCategory />
          
          <div className="self-stretch flex flex-col justify-start items-start gap-[30px]">
            <div className="px-[5px] inline-flex justify-start items-center gap-2.5">
              <div className="w-0 h-[27.50px] border-[#e4e4e4] border-2 rounded-xl" />
              <div className="justify-center text-black text-2xl font-bold leading-9">補償・返品・再鑑定</div>
            </div>
            
            <div className="self-stretch flex flex-col justify-start items-start gap-2.5">
              <div className="justify-center text-black text-xl font-bold leading-[30px]">受取拒否や返送はできる？</div>
              <div className="self-stretch pl-5 flex flex-col justify-center items-start gap-2.5">
                <div className="self-stretch justify-center text-black text-base font-normal leading-7">商品イメージとの相違や、お客様のご都合によるキャンセル・返品は、いかなる場合でもお受けしておりません。<br/>そのため、お受け取りを拒否された商品についても、補償の対象外となりますので、あらかじめご了承ください。<br/>万が一、運送会社での保管期限を過ぎたことにより商品がDONDON事務局へ返送された場合は、当社よりお客様へご連絡を差し上げます。</div>
                <div className="self-stretch flex flex-col justify-start items-start">
                  <div className="justify-center text-black text-base font-bold leading-7">注意事項</div>
                  <div className="justify-center text-black text-base font-normal leading-7">・取引成立後は、お客様のご都合によるキャンセルはお受けしておりません。<br/>・購入者様側の操作によってキャンセル手続きを行った場合には、キャンセル料は発生いたしません。</div>
                </div>
              </div>
            </div>
            
            <div className="self-stretch flex flex-col justify-start items-start gap-2.5">
              <div className="justify-center text-black text-xl font-bold leading-[30px]">補償対象・対象外の条件は？</div>
              <div className="self-stretch pl-5 flex flex-col justify-center items-start gap-2.5">
                <div className="self-stretch justify-center text-black text-base font-normal leading-7">お届けした商品に偽造品の疑いがある場合や、ガイドラインの基準を満たさない汚損・破損が確認された場合、以下の条件をすべて満たしている場合に限り、補償の対象とさせていただきます。<br/>※商品の交換を承ることはできません</div>
                <div className="justify-center text-black text-base font-normal leading-7">・商品到着日から7日以内であること<br/>・DONDONの鑑定済シールが未剥離の状態であること<br/>・開封時の動画をご提供いただけること※ボックスのみ<br/>・商品が未使用であること</div>
                <div className="flex flex-col justify-start items-start">
                  <div className="justify-center text-black text-base font-normal leading-7">詳細は以下のページをご確認ください。</div>
                  <Link to={`/terms/compensation${location.search}`} className="justify-center text-[#00b8f9] text-base font-normal underline leading-7 hover:text-[#0099d6]">補償について</Link>
                </div>
              </div>
            </div>
            
            <div className="self-stretch flex flex-col justify-start items-start gap-2.5">
              <div className="justify-center text-black text-xl font-bold leading-[30px]">鑑定シールの画像が必要な理由は？</div>
              <div className="self-stretch pl-5 flex flex-col justify-center items-start gap-2.5">
                <div className="self-stretch justify-center text-black text-base font-normal leading-7">補償をご依頼いただいた商品につきましては、鑑定・検品時の記録と、購入者様よりご提示いただいた画像を照らし合わせながら、商品状態の確認をおこなっております。<br/>ご提示いただいた画像の商品と、当社が発送前に記録している状態に相違がないかという点も確認の対象となるため、補償をご希望の際は、鑑定済シールがついた状態であることが必須条件となります。</div>
                <div className="flex flex-col justify-start items-start">
                  <div className="justify-center text-black text-base font-normal leading-7">補償に関するご案内は、以下のページをご参照ください。</div>
                  <Link to={`/terms/compensation${location.search}`} className="justify-center text-[#00b8f9] text-base font-normal underline leading-7 hover:text-[#0099d6]">補償について</Link>
                </div>
              </div>
            </div>
            
            <div className="self-stretch flex flex-col justify-start items-start gap-2.5">
              <div className="justify-center text-black text-xl font-bold leading-[30px]">当社作業工程で破損・紛失が発生した場合は？</div>
              <div className="self-stretch pl-5 inline-flex justify-start items-center gap-2.5">
                <div className="flex-1 justify-center text-black text-base font-normal leading-7">当社では、鑑定・検品など各作業工程において、すべての商品を丁寧に取り扱い・管理しております。<br/>しかしながら、当社内での作業工程において不手際が発生し、商品の破損・紛失が確認された場合には、該当の取引をキャンセルのうえ、売上金額（＝取引金額 ー 出品手数料）を出品者指定の口座へお振込いたします。<br/>お振込にあたっては、DONDONからのご案内に従い、お振込先の情報をご連絡ください。</div>
              </div>
            </div>
          </div>
          
          <TermFaqCategory />
        </div>
      </div>
      
      {!isMobile && <Footer />}
    </div>
  );
};

export default FaqCompensationReturnReassessmentPage;